import { render } from "./EditTrimInfo.vue?vue&type=template&id=68e9379a&scoped=true"
import script from "./EditTrimInfo.vue?vue&type=script&lang=js"
export * from "./EditTrimInfo.vue?vue&type=script&lang=js"

import "./EditTrimInfo.vue?vue&type=style&index=0&id=68e9379a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e9379a"]])

export default __exports__